import React, { useState, useEffect } from 'react';
import { getDetalleMarcadas } from '../../../services/detalleMarcadas'; // Asegúrate de que la ruta sea correcta
import "./bopi.css";
import { getApiClientFront, getApiClientBack, getURLFront } from "../../../api/api";

// const apiUrlMap = {
//   "pruebabopiweb.oepm.es": "https://pruebabopiweb.oepm.es/apibopiweb",
//   "prebopiweb.oepm.es": "https://prebopiweb.oepm.es/apibopiweb",
//   "bopiweb.oepm.es": "https://bopiweb.oepm.es/apibopiweb",
  
//   "localhost": "http://localhost:5000",
//   "defaultApiUrl": "Error",
// };

// const apiUrlMap = {
//   // "pruebabopiweb.oepm.es": "https://pruebabopiweb.oepm.es",
//   "pruebasede.oepm.gob.es": "https://pruebasede.oepm.gob.es/bopi",
//   "prebopiweb.oepm.es": "https://prebopiweb.oepm.es",
//   "bopiweb.oepm.es": "https://bopiweb.oepm.es",
  
//   "localhost": "http://localhost:3000/bopi",
//   "defaultApiUrl": "Error",
// };

// const baseURL = apiUrlMap[window.location.hostname] || apiUrlMap["defaultApiUrl"];
// // const baseURL = "http://localhost:3000";

const DetalleMarcadas = () => {

  const [registros, setRegistros] = useState([]); // Para almacenar los registros si se reciben varios
  const [resultado, setResultado] = useState(null); // Para almacenar un solo resultado
  const [resultadoBusqueda, setResultadoBusqueda] = useState(null); // Estado para almacenar los resultados del backend

  useEffect(async () => {
    window.__isReady = true; // aviso a la ventana padre de que la ventana hijo ya está lista para recibir, o puede recibir cuando no está preparada y se pierde.
    const baseURL = await getURLFront();
    const handleMessage = (event) => {            
      // alert(JSON.stringify(event.data));      
      const urlCompleta = new URL("/bopi", event.origin).href;
      if (urlCompleta === baseURL) {
        const { registros, resultado } = event.data;
        
        if (event.data && event.data.type === "registrosSeleccionados") {
          // Reiniciamos estado para forzar re-render
          setResultadoBusqueda(null);
          setRegistros([]);
          setResultado(null);            

          // Si se recibieron varios registros
          if (registros && registros.length > 0) {
            setRegistros(registros); // Guardamos los registros en el estado

            // Extraemos los "id" y "tomo" de los registros para enviarlos al backend
            const ids = registros.map(registro => registro.id);
            const tomos = registros.map(registro => registro.tomo);

            const fetchAnotaciones = async () => {
              try {
                const resultado = await getDetalleMarcadas(ids, tomos); // Llamada al backend
                setResultadoBusqueda(resultado); // Guardamos el HTML en el estado
              } catch (error) {
                console.error('Error al obtener detalle marcadas:', error);
              }
            };

            fetchAnotaciones(); // Realizamos la llamada al backend

          // Si se recibió un solo resultado
          } else if (resultado) {          
            setResultado(resultado); // Guardamos el resultado único
            // Si se desea, puedes enviar el id o cualquier otra propiedad del resultado a un backend
            const fetchAnotaciones = async () => {
              try {
                const resultadoBackend = await getDetalleMarcadas([resultado.id], [resultado.tomo]);              
                setResultadoBusqueda(resultadoBackend);
              } catch (error) {
                console.error('Error al obtener detalle marcadas:', error);
              }
            };

            fetchAnotaciones();
          }
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []); // Se ejecuta solo cuando el componente se monta

  return (
    <div>
      <h1>
      {registros.length === 1 || resultado ? "Detalle" : "Detalles Marcadas"}
      </h1>
      {resultadoBusqueda ? (
        <div dangerouslySetInnerHTML={{ __html: resultadoBusqueda }} />
      ) : (
        <p>Cargando datos...</p>
      )}
    </div>
  );
};

export default DetalleMarcadas;
